const AIRLINE_NAMES: Record<string, string> = {
  KL: "KLM",
  DE: "Condor",
  LH: "Lufthansa",
  FR: "Ryanair",
  OS: "Austrian",
  LX: "Swiss",
  SN: "Brussels Airlines",
  EW: "Eurowings",
  W6: "Wizz Air",
  U2: "easyJet",
  BA: "British Airways",
  IB: "Iberia",
  VY: "Vueling",
  AF: "Air France",
  TP: "TAP Air Portugal",
  LO: "LOT Polish",
  SU: "Aeroflot",
  TK: "Turkish Airlines",
  AY: "Finnair",
  SK: "SAS",
  DY: "Norwegian",
  BT: "Air Baltic",
  FZ: "flydubai",
  EK: "Emirates",
  QR: "Qatar Airways",
  EY: "Etihad",
  AA: "American Airlines",
  DL: "Delta",
  UA: "United",
}

export function resolveAirlineName(code: string): string {
  return AIRLINE_NAMES[code] ?? code
}
